/* eslint-disable complexity */
import React, { useEffect, useState } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useSelector } from 'react-redux';
import { FormattedMessage, useIntl } from 'react-intl';

import { isSageIDUser, isSXPManagedUser } from '@futrli/shared-services';

import { StoreState } from '../core/types';
import { Header } from './components/header/header';
import { MultiFactorAuth } from './components/multi-factor-auth';
import Typography from 'carbon-react/lib/components/typography';
import { Select, Option } from 'carbon-react/lib/components/select';

import * as styles from './my-profile.scss';
import { ChangePassword } from './components/change-password';
import { dispatchLocaleChangeEvent, useSupportedLocales } from '@futrli/localisation';

export const MyProfile = () => {
  const intl = useIntl();
  const [selectedLocale, setSelectedLocale] = useState(intl.locale);
  const { sageIdUser, sxpManagedUser } = useSelector((store: StoreState) => {
    const user = store.authReducers.authenticatedUser;
    return {
      sageIdUser: isSageIDUser(user),
      sxpManagedUser: isSXPManagedUser(user)
    };
  });
  const supportedLocales = useSupportedLocales();

  useEffect(() => {
    setSelectedLocale(intl.locale);
  }, [intl.locale]);

  const handleLocaleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.value && event.target.value !== selectedLocale) {
      setSelectedLocale(event.target.value);
      dispatchLocaleChangeEvent(event.target.value);
    }
  };

  const flags = useFlags();

  if (sxpManagedUser) {
    return null;
  }

  return (
    <div>
      <Header />
      <div style={{ padding: '30px 40px', display: 'flex', flexWrap: 'wrap', gap: 30 }}>
        {!sageIdUser && (
          <>
            <ChangePassword />
            <MultiFactorAuth />
          </>
        )}
        {flags.switchLocale && (
          <div className={styles.container}>
            <Typography mb="15px" fontWeight="700" fontSize="18px">
              <FormattedMessage id="my_profile.select_language" defaultMessage="Select language" />
            </Typography>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Select
                onChange={handleLocaleChange}
                id="locale-select"
                value={selectedLocale}
                label={intl.formatMessage({
                  id: 'my_profile.select_language',
                  defaultMessage: 'Select language'
                })}
                name="select_language"
                size="medium"
                style={{ width: 250 }}
              >
                {supportedLocales.map(locale => (
                  <Option key={locale.value} {...locale} />
                ))}
              </Select>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
